import _Object$assign from "babel-runtime/core-js/object/assign";
import _ from "lodash";
import Vue from "vue";
import loading from "./src/loading";
var Loading = Vue.extend(loading);

function initLoadingNode() {
  var instance = new Loading();
  instance.vm = instance.$mount();
  instance.noPlayVoice = false;
  document.body.appendChild(instance.vm.$el);
  return instance;
}

Vue.prototype.myLoading = function (options) {
  var currentLoadingNode = document.getElementById("loadingNode");
  if (currentLoadingNode) {
    document.body.removeChild(currentLoadingNode);
  }

  if (options.showLoading === false) {
    return false;
  }

  var instanceNow = initLoadingNode();

  if (_.isObject(options)) {
    _Object$assign(instanceNow, options);
  } else {
    instanceNow.loadingText = options;
    instanceNow.showLoading = true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/loading/index.js
// module id = 1563
// module chunks = 2